import { defineComponent as _defineComponent } from 'vue'
import { onUnmounted, ref, Ref } from 'vue'
import { onMounted } from "vue"
import { usePiniaState } from "@/store/userPinia";
import EventBus from "@/uitls/EventBus";
import { imMessageListModel } from "@/model/chatModel";
import { YMPush } from "@/uitls/uitls";
import { useRouter } from "vue-router";
import { getIMListAll } from "@/network/db/dbServe";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  name: 'Group',
  setup(__props, { expose }) {
  expose();

const { t } = useI18n()
const router = useRouter();


const userStore = usePiniaState();
const { toLogin } = userStore;
const msgList = ref([]) as Ref<Array<imMessageListModel>>

onMounted(() => {
    toLogin();
    getMsgList()
});

 
onUnmounted(() => {
    // EventBus.all.clear();
    YMPush('MAIN', 'ChatGroup')
    EventBus.off("imlist")
});

EventBus.on("imlist", () => {
    getMsgList()
});

const getMsgList = async () => {
    const v = await getIMListAll()
    console.log(v);
    msgList.value = v as [];
}
const toChat = (data) => {
    console.log(data);
    router.push(`/chat/?id=${data.chatkey}`)
}
const onClickLeft = () => {
    router.back();
}

//获取会话列表，获取数据库里面的

const __returned__ = { t, router, userStore, toLogin, msgList, getMsgList, toChat, onClickLeft }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})